import { Button, ButtonGroup, Card, Image, Overlay } from 'react-bootstrap';

import { Handle } from 'react-flow-renderer';
import Icon from '@amzn/meridian/icon';
import React, { useRef, useState } from 'react';
import branchingIcon from './workflow-ab-branching.png';
import checkKnockoutTokens from '@amzn/meridian-tokens/base/icon/check-knockout';
import deleteIcon from './workflow-node-delete.png';
import editIcon from './workflow-edit.png';
import metricsIcon from './workflow-ab-metrics.png';
import { WorkflowResourcePopOver } from '../../popover/WorkflowResourcePopOver';

const NODE_TEXT = 'Start A/B';

export const BranchingNode = ({ id, data }) => {
  const popOverTarget = useRef(null);
  const [isHoverOver, setIsHoverOver] = useState(false);

  const onMouseEnterHandler = () => {
    setIsHoverOver(true);
  };

  const onMouseLeaveHandler = () => {
    setIsHoverOver(false);
  };
  return (
    <div className="node-size">
      <Handle type="target" position="left" />
      <Card className="h-100">
        {data.canEdit ? (
          <Card.Header className="p-0 text-center">
            <ButtonGroup size="sm">
              <Button
                className="node-icon-size p-2px mx-3px"
                variant="outline-warning"
                onClick={data.callbacks.addAbTreatmentGroup}
              >
                <Image src={branchingIcon} fluid />
              </Button>
              <Button
                className="node-icon-size p-2px mx-3px"
                variant="outline-success"
                onClick={() => data.callbacks.editNode(id)}
              >
                <Image src={editIcon} fluid />
              </Button>
              <Button
                className="node-icon-size p-2px mx-3px"
                variant="outline-success"
                onClick={() => data.callbacks.lookupAbMetrics(id)}
              >
                <Image src={metricsIcon} fluid />
              </Button>
              <Button
                className="node-icon-size p-2px mx-3px"
                variant="outline-danger"
                onClick={() => data.callbacks.removeNode(id)}
              >
                <Image src={deleteIcon} fluid />
              </Button>
              <Button
                className="node-icon-size p-0 mx-3px"
                variant="outline-success"
                onClick={data.callbacks.completeAbTest}
              >
                <Icon tokens={checkKnockoutTokens} />
              </Button>
            </ButtonGroup>
          </Card.Header>
        ) : null}
        <Card.Body
          className="py-1 text-center"
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          ref={popOverTarget}
        >
          <Card.Text>{NODE_TEXT}</Card.Text>
        </Card.Body>
        <Overlay target={popOverTarget.current} show={isHoverOver} placement="bottom">
          {({ ...props }) => <WorkflowResourcePopOver node={data.node} {...props} />}
        </Overlay>
      </Card>
      <Handle type="source" position="right" />
    </div>
  );
};
